import VideoTestimonials from 'common/video_testimonials';

if (document.querySelector('.js-community-page')) {
  new VideoTestimonials();
}

// Community Featured Stories
const featuredStoryGroupsDataAttr =
  '[data-js="community-featured-story-group"]';
const seeMoreFeaturedStoriesButtonDataAttr = '[data-js="community-see-more"]';
const initialNumberOfFeaturedStoryGroups = 2;

// Community Testimonials
const testimonialGroupsDataAttr =
  '[data-js="community-testimonial-story-group"]';
const seeMoreTestimonialsButtonDataAttr =
  '[data-js="community-see-more-testimonials"]';
const initialNumberOfTestimonialGroups = 3;

const setupCommunitySeeMore = (
  storyGroupsDataAttr,
  numberOfStoryGroups,
  seeMoreButtonDataAttr
) => {
  const storyGroups = Array.from(
    document.querySelectorAll(storyGroupsDataAttr)
  );

  const initialNumberofStoryGroups = numberOfStoryGroups;

  if (storyGroups.length > 0) {
    const seeMoreButton = document.querySelector(seeMoreButtonDataAttr);

    seeMoreButton.onclick = e => {
      numberOfStoryGroups += initialNumberofStoryGroups;
      showStories();
      e.preventDefault();
    };

    // shows the currently desired number of story groups
    const showStories = () => {
      storyGroups
        .slice(0, numberOfStoryGroups)
        .forEach(el => el.classList.remove('community-story__group--hidden'));

      if (numberOfStoryGroups >= storyGroups.length) {
        // we've reached the end of the list, hide the see more button
        seeMoreButton.classList.add('community-stories__see-more--hidden');
      }
    };

    // show the initial stories
    showStories();
  }
};

setupCommunitySeeMore(
  featuredStoryGroupsDataAttr,
  initialNumberOfFeaturedStoryGroups,
  seeMoreFeaturedStoriesButtonDataAttr
);

setupCommunitySeeMore(
  testimonialGroupsDataAttr,
  initialNumberOfTestimonialGroups,
  seeMoreTestimonialsButtonDataAttr
);
